class ExportRTSelections {
  static ALL = 'all';

  static SELECTED_ONLY = 'selectedOnly';
}

export default ExportRTSelections;
